import {
  ensureAuthCacheSynced,
  getAuthRole,
  getAuthUserId,
  clearAuthSessionMemory,
} from "./authSession";

class TokenService {
  getLocalRefreshToken() {
    const user = JSON.parse(localStorage.getItem("user"));
    return user?.refreshToken;
  }

  getLocalAccessToken() {
    const user = JSON.parse(localStorage.getItem("user"));
    return user?.accessToken;
  }

  updateLocalAccessToken(token) {
    let user = JSON.parse(localStorage.getItem("user"));
    user.accessToken = token;
    localStorage.setItem("user", JSON.stringify(user));
    // New token may include role claims — resync identity cache.
    ensureAuthCacheSynced();
  }

  getUser() {
    return JSON.parse(localStorage.getItem("user"));
  }

  getUserID() {
    return getAuthUserId() || localStorage.getItem("user_id");
  }

  getUserRole() {
    return getAuthRole();
  }

  setUser(user) {
    localStorage.setItem("user", JSON.stringify(user));
    ensureAuthCacheSynced();
  }

  removeUser() {
    localStorage.removeItem("user");
    clearAuthSessionMemory();
  }
}

export default new TokenService();
